import { render, staticRenderFns } from "./CKEditorWidget.vue?vue&type=template&id=47cbf7a0&scoped=true"
import script from "./CKEditorWidget.vue?vue&type=script&lang=ts"
export * from "./CKEditorWidget.vue?vue&type=script&lang=ts"
import style0 from "./CKEditorWidget.vue?vue&type=style&index=0&id=47cbf7a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbf7a0",
  null
  
)

export default component.exports